import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { createErrorAction } from '../../../utils';
import useQualificationYear from 'Common/Utils/Hooks/useQualificationYear';
import useActiveQualificationYear from 'Common/Utils/Hooks/useActiveQualificationYear';
import isYearFixed from 'Common/Utils/isYearFixed';
import { UPDATE_ACTIVE_QUALIFICATION_YEAR } from '../../../Redux/Enums/Contracts.Globals.Enums';
import View from './YearSelector.view';

const YearSelector = ({ grouping = false, updateYear, year, numberOfPreviousYears = false, numberOfFutureYears = false, listOfYears = false, addLoopCheck = false}) => {
    var { qualYearLoaded, qualYear } = useQualificationYear();
    var { activeQualYearLoaded, activeQualYear } = useActiveQualificationYear();
    const dispatch = useDispatch();
    const handleErrors = errors => dispatch(createErrorAction(errors));
    if (grouping) {
        var fixedYear = isYearFixed(grouping);
    }
    useEffect(() => {
        if (fixedYear) {
            updateYear(String(qualYear));
        }

        if (String(activeQualYear) !== "" && (addLoopCheck === false || (addLoopCheck === true && activeQualYearLoaded === false) ))
        {
            updateYear(String(activeQualYear));
        }
    }, [fixedYear, qualYear, updateYear]);

    if (!qualYearLoaded) {
        handleErrors(['Cannot show Year Selector as no qualification year is loaded']);
        return null;
    }

    const previousYears = [];
    if (numberOfPreviousYears) {
        for (let i = 0; i < numberOfPreviousYears; i++) {
            previousYears.push(String((qualYear - 1) - i));
        }
    }
    

    const futureYears = [];
    if (numberOfFutureYears) {
        for (let i = 0; i < numberOfFutureYears; i++) {
            futureYears.push(String((qualYear + 1) + i));
        }
    };

    var yearList = [];
    if (listOfYears.length > 0) {
        for (let i = 0; i < listOfYears.length; i++) {
          
            yearList.push(String(listOfYears[i]));
        }
        qualYear = "";
    };

    const handleYearUpdate = event => {
        const selectedYear = event.target.value;
        dispatch({ type: UPDATE_ACTIVE_QUALIFICATION_YEAR, payload: selectedYear });
        updateYear(selectedYear);
    };

    return <View qualYear={String(qualYear)} previousYears={previousYears.sort()} futureYears={futureYears.sort()} yearList={yearList.sort()} fixedYear={fixedYear} updateYear={handleYearUpdate} selectedYear={String(activeQualYear)}></View>;
};

export default YearSelector;